var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasNeverActivateOrder
    ? _c(
        "div",
        { staticClass: "x-notify" },
        [
          _c(
            "p",
            [
              _vm._v(
                " 当前账号在线下有购买产品/服务，需先激活才能正常使用，请尽快激活。 "
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "mini" },
                  on: { click: _vm.clickActive },
                },
                [_vm._v("去激活")]
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.activeProductDialog,
                "close-on-click-modal": false,
                width: "640px",
                "append-to-body": true,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.activeProductDialog = $event
                },
              },
            },
            [
              _c("template", { slot: "title" }, [_vm._v("激活线下产品/服务")]),
              _c("p", { staticClass: "mt-20" }, [
                _vm._v(
                  "您在线下有购买产品/服务，需先激活才能正常使用，请尽快激活；激活后，产品正式生效，开始计算产品服务时间；"
                ),
              ]),
              _c(
                "el-row",
                { staticStyle: { "padding-left": "15px" } },
                _vm._l(_vm.activeList, function (item, index) {
                  return _vm.categoryList.length > 0
                    ? _c(
                        "div",
                        {
                          key: index,
                          staticClass: "fl box mr-20 mt-20",
                          class: { activeBorder: !item.isshow },
                          on: {
                            click: function ($event) {
                              return _vm.chooseActive(item)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "fl",
                            attrs: {
                              src: require("@/assets/home/3333.png"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "fl ml-10" }, [
                            _c("section", { staticClass: "p1" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.categoryList.filter(function (e) {
                                    return e.ID === item.CategoryID
                                  })[0].Title
                                )
                              ),
                            ]),
                            _c("section", { staticClass: "p2" }, [
                              _vm._v(_vm._s(item.PackageName)),
                            ]),
                          ]),
                          _c("p", { staticClass: "check-icon" }, [
                            _c("span", { staticClass: "el-icon-check" }),
                          ]),
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.activeProductDialog = false
                        },
                      },
                    },
                    [_vm._v("下次再说")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showAllactive },
                    },
                    [_vm._v(" 立即激活")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              staticClass: "footerDialog",
              attrs: {
                title: "验证手机",
                visible: _vm.idPhoneDialog,
                width: "640px",
                "close-on-click-modal": false,
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.idPhoneDialog = $event
                },
                close: function ($event) {
                  return _vm.resetForm("idcardForm")
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { "padding-left": "50px" } },
                [
                  _c("p", [
                    _vm._v(
                      "激活后，将开始计算产品服务时间，为确保您账号的安全性，需进行身份验证"
                    ),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "idcardForm",
                      staticClass: "mt-20",
                      attrs: {
                        model: _vm.idcardForm,
                        rules: _vm.rules,
                        "label-width": "80px",
                      },
                      nativeOn: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _c("el-form-item", { attrs: { label: "手机号：" } }, [
                        _vm.userPhone && _vm.userPhone !== undefined
                          ? _c("span", [
                              _vm._v(
                                _vm._s(_vm.userPhone.substr(0, 3)) +
                                  "****" +
                                  _vm._s(_vm.userPhone.substr(-4))
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: "验证码：", prop: "code" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { size: "medium", maxlength: 5 },
                            model: {
                              value: _vm.idcardForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.idcardForm, "code", $$v)
                              },
                              expression: "idcardForm.code",
                            },
                          }),
                          _c("verification-button", {
                            attrs: { stop: _vm.secodeIdStop },
                            on: { send: _vm.SendMobileCode },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: { width: "100px" },
                              attrs: { type: "primary", size: "small" },
                              on: { click: _vm.clickAllactive },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm.xMessageDialog
            ? _c("div", { staticClass: "x-dialog" }, [
                _vm._v(
                  " 请勿频繁获取验证码，稍后再尝试（" + _vm._s(_vm.time) + "s) "
                ),
              ])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }